import * as React from "react";
import { Button } from "@/components/ui/button";
import { DataTable } from "@/components/DataTable";
import { formatDateTime } from "@/lib/display-labels";
import type { AuditEntry } from "./helpers";

interface AuditTableProps {
  entries: AuditEntry[];
  expandedId: string | null;
  onToggleExpand: (id: string) => void;
}

export function AuditTable({
  entries,
  expandedId,
  onToggleExpand,
}: AuditTableProps): React.ReactElement {
  return (
    <DataTable
      data={entries}
      rowKey={(e) => e.id}
      emptyState="Sem registros de auditoria."
      columns={[
        {
          header: "Quando",
          accessor: (e) => formatDateTime(e.createdAt),
          className: "text-muted-foreground text-xs",
        },
        {
          header: "Ação",
          accessor: (e) => (
            <span className="bg-muted rounded-full px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider">
              {e.action}
            </span>
          ),
        },
        { header: "Entidade", accessor: (e) => e.entityType },
        {
          header: "ID",
          accessor: (e) => <span className="font-mono text-[10px]">{e.entityId.slice(0, 8)}</span>,
        },
        {
          header: "Usuário",
          accessor: (e) => (
            <span className="font-mono text-[10px]">
              {e.userId ? e.userId.slice(0, 8) : "sistema"}
            </span>
          ),
        },
        {
          header: "",
          accessor: (e) => (
            <Button variant="ghost" size="sm" onClick={() => onToggleExpand(e.id)}>
              {expandedId === e.id ? "Ocultar" : "Diff"}
            </Button>
          ),
          className: "text-right",
        },
      ]}
    />
  );
}
